import { FC } from 'react';
import useSWR from 'swr';
import { Stack, Typography } from '@mui/material';

import { DataBox, InfoBox, LeftTitle } from '@styles/ContactManager/HeaderStyles';

import { Modal } from '@shared/components/modals/Modal';
import { ConfigDataType, IStateData, IStateModalProps } from '../interfaces';

export const StateModal: FC<IStateModalProps> = ({ stateValue, handleClose }) => {
  const { data: stateData } = useSWR<IStateData>(
    stateValue && `/configuration-service/state-regulation-configurations/${stateValue}`,
  );

  const dataConfig: ConfigDataType[]  = [
      {
        label: 'Title Holding',
        value: stateData?.titleHoldingStatus ?? null,
      },
      {
        label: 'Out of State Title Allowed',
        value: stateData?.isOutOfStateTitleAllowed ?? null,
      },
      {
        label: 'SOR Required - Add',
        value: stateData?.addStatus ?? null,
      },
      {
        label: 'SOR Required - Drop',
        value: stateData?.sorRequiredStatus ?? null,
      },
      {
        label: 'Notary Required',
        value: stateData?.notaryRequiredStatus ?? null,
      },
      {
        label: 'Allow Product Tax and Sales Tax',
        value: stateData?.isAllowProductAndSalesTax ?? null,
      },
    ];
  
 
  return (
    <Modal
      open
      title="State Requirements"
      dialogWidth="1100px"
      onClose={handleClose}
    >
      <>
        <Typography
          justifyContent="center"
          variant="h3"
          mb={2}
        >
          {stateData?.state}
        </Typography>

        <Stack
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          flexWrap="wrap"
          mb={3}
        >
          {dataConfig.map((item: ConfigDataType, index: number) => {
            return (
              <DataBox
                key={index}
                label={item.label}
                value={item.value}
              />
            );
          })}
        </Stack>
        {stateData?.salesTaxInformation && (
          <InfoBox>
            <LeftTitle>Sales Tax</LeftTitle>

            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: stateData.salesTaxInformation }}
            />
          </InfoBox>
        )}

        {stateData?.specificRequirements && (
          <InfoBox>
            <LeftTitle>Specific Requirements</LeftTitle>

            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: stateData.specificRequirements }}
            />
          </InfoBox>
        )}

        {stateData?.titleDocuments && (
          <InfoBox>
            <LeftTitle>Title Documents</LeftTitle>

            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: stateData.titleDocuments }}
            />
          </InfoBox>
        )}
      </>
    </Modal>
  );
};
